import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const ZoomIn = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M17.5 6C11.1487 6 6 11.1487 6 17.5C6 23.8513 11.1487 29 17.5 29C23.8513 29 29 23.8513 29 17.5C29 11.1487 23.8513 6 17.5 6ZM4 17.5C4 10.0442 10.0442 4 17.5 4C24.9558 4 31 10.0442 31 17.5C31 20.868 29.7667 23.9479 27.727 26.3128L35.7071 34.2929C36.0976 34.6834 36.0976 35.3166 35.7071 35.7071C35.3166 36.0976 34.6834 36.0976 34.2929 35.7071L26.3128 27.727C23.9479 29.7667 20.868 31 17.5 31C10.0442 31 4 24.9558 4 17.5ZM17.5 10C18.0523 10 18.5 10.4477 18.5 11V16.5L24 16.5C24.5523 16.5 25 16.9477 25 17.5C25 18.0523 24.5523 18.5 24 18.5L18.5 18.5V24C18.5 24.5523 18.0523 25 17.5 25C16.9477 25 16.5 24.5523 16.5 24V18.5L11 18.5C10.4477 18.5 10 18.0523 10 17.5C10 16.9477 10.4477 16.5 11 16.5L16.5 16.5V11C16.5 10.4477 16.9477 10 17.5 10Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default ZoomIn;
